import { useEffect, useState } from "react";
import { mostraAlertaError, mostraAlertaOk, mostraAlertaWarning } from "../../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import ModalBootstrap from "../../../../componentes/modal/ModalBootstrap";
import { PromocionesEditar, PromocionesListar } from "../../../../configuracion/apiUrls";

const ModalPromocion = ({ datos, token, setListaPromociones, ActualizarLista }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [formData, setFormData] = useState({
        id: null,
        nombre: "",
        descripcion: "",
        tipo: "Unico",
        fechaInicio: "",
        fechaFin: "",
        hora_inicio: "",
        hora_fin: "",
        diasSemana: "",
        estado: "Activo",
        descuento: "5%",
        descuentoTotal: 0,
        limite_total: "",
        limite_cliente: "",
    });

    const dias = ["Todos", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

    useEffect(() => {
        if (datos) {
            const fechaIni = datos.fechaInicio?.slice(0, 10) || "";
            const fechaFin = datos.fechaFin?.slice(0, 10) || "";
            const horaIni = datos.hora_inicio?.slice(0, 5) || "";
            const horaFin = datos.hora_fin?.slice(0, 5) || "";

            setFormData({
                id: datos.id,
                nombre: datos.nombre || "",
                descripcion: datos.descripcion || "",
                tipo: datos.tipo || "Unico",
                fechaInicio: fechaIni,
                fechaFin: fechaFin,
                hora_inicio: horaIni,
                hora_fin: horaFin,
                diasSemana: datos.diasSemana || "",
                estado: datos.estado || "Activo",
                descuento: datos.descuento || "5%",
                descuentoTotal: datos.descuentoTotal ?? 0,
                limite_total: datos.limite_total ?? "",
                limite_cliente: datos.limite_cliente ?? "",
            });
        }
    }, [datos]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleDiasSemanaChange = (dia, checked) => {
        let seleccionados = formData.diasSemana.split(",").map(d => d.trim()).filter(Boolean);
        if (checked) {
            if (dia === "Todos") {
                seleccionados = ["Todos"];
            } else {
                seleccionados = seleccionados.filter(d => d !== "Todos");
                if (!seleccionados.includes(dia)) {
                    seleccionados.push(dia);
                }
            }
        } else {
            seleccionados = seleccionados.filter(d => d !== dia);
        }
        setFormData(prev => ({ ...prev, diasSemana: seleccionados.join(",") }));
    };

    const errorNombre = !formData.nombre.trim();
    const errorFecha = !formData.fechaInicio || !formData.fechaFin;
    const errorLimites = formData.limite_total < 0 || formData.limite_cliente < 0;

    const BotonEditar = () => {
        return (
            <button
                type="button"
                className="btn btn-warning"
                onClick={editarPromocion}
            >
                Editar
                <i className="fas fa-edit ml-3" />
            </button>
        );
    };

    const editarPromocion = () => {
        if (errorNombre || errorFecha || errorLimites) {
            mostraAlertaWarning("Existen errores en la introducción de campos");
        } else {
            try {
                AxiosPrivado.defaults.headers.common["Authorization"] = `Bearer ${token}`;
                const url = `${PromocionesEditar}?id=${formData.id}`;
                AxiosPrivado.put(url, formData)
                    .then(() => {
                        mostraAlertaOk("Promoción actualizada correctamente");
                        ActualizarLista(PromocionesListar, setListaPromociones);
                        setModalIsOpen(false);
                    })
                    .catch((error) => {
                        const { response } = error;
                        if (response?.data && Array.isArray(response.data)) {
                            const mensajesError = response.data.map(e => e.msg).join(', ');
                            mostraAlertaError(mensajesError, "error");
                        } else if (response?.data?.msj || response?.data?.error?.message) {
                            const msj = response?.data?.msj || response?.data?.error?.message;
                            mostraAlertaError(msj, "error");
                        }
                    });
            } catch (error) {
                mostraAlertaError("Error en la petición");
            }
        }
    };
    
    return (
        <ModalBootstrap
            titulo="Editar Promoción"
            nombreBoton=""
            estiloBoton="btn btn-warning"
            iconBoton="fas fa-edit ml-0 text-white"
            pie={
                <BotonEditar/>
            }
            modalIsOpen={modalIsOpen}
            setModalIsOpen={setModalIsOpen}
            size="xl"
        >
            <div className="row gy-4 gx-3">
                <div className="col-md-6 mb-3">
                    <label className="form-label">Nombre</label>
                    <input className="form-control" name="nombre" value={formData.nombre} onChange={handleChange} />
                </div>
                <div className="col-md-6 mb-3">
                    <label className="form-label">Descripción</label>
                    <input className="form-control" name="descripcion" value={formData.descripcion} onChange={handleChange} />
                </div>

                <div className="col-md-4 mb-3">
                    <label className="form-label">Tipo</label>
                    <select className="form-select mx-1" name="tipo" value={formData.tipo} onChange={handleChange}>
                        {["Total", "Unico", "Combo", "Evento"].map(op => (
                            <option key={op} value={op}>{op}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-4 mb-3">
                    <label className="form-label">Descuento</label>
                    <select className="form-select mx-1" name="descuento" value={formData.descuento} onChange={handleChange}>
                        {["5%", "10%", "15%", "20%", "25%", "30%", "35%", "40%", "45%", "50%"].map(op => (
                            <option key={op} value={op}>{op}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-4 mb-3">
                    <label className="form-label">Estado</label>
                    <select className="form-select mx-1" name="estado" value={formData.estado} onChange={handleChange}>
                        {["Activo", "Inactivo", "Agotado"].map(op => (
                            <option key={op} value={op}>{op}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">Fecha Inicio</label>
                    <input className="form-control" type="date" name="fechaInicio" value={formData.fechaInicio} onChange={handleChange} />
                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">Fecha Fin</label>
                    <input className="form-control" type="date" name="fechaFin" value={formData.fechaFin} onChange={handleChange} />
                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">Hora Inicio</label>
                    <input className="form-control" type="time" name="hora_inicio" value={formData.hora_inicio} onChange={handleChange} />
                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">Hora Fin</label>
                    <input className="form-control" type="time" name="hora_fin" value={formData.hora_fin} onChange={handleChange} />
                </div>

                <div className="col-12 mb-3">
                    <label className="form-label">Días de la Semana</label>
                    <div className="d-flex flex-wrap">
                        {dias.map(dia => (
                            <div key={dia} className="form-check me-4 mb-2" style={{ minWidth: "120px" }}>
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`${datos.id}-${dia}`}
                                    checked={formData.diasSemana.split(",").map(d => d.trim().toLowerCase()).includes(dia.toLowerCase())}
                                    onChange={(e) => handleDiasSemanaChange(dia, e.target.checked)}
                                />
                                <label className="form-check-label ms-2" htmlFor={`${datos.id}-${dia}`}>
                                    {dia}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="col-md-4 mb-3">
                    <label className="form-label">Descuento Total (L)</label>
                    <input className="form-control" type="number" step="0.01" name="descuentoTotal" value={formData.descuentoTotal} onChange={handleChange} />
                </div>
                <div className="col-md-4 mb-3">
                    <label className="form-label">Límite Total</label>
                    <input className="form-control" type="number" name="limite_total" value={formData.limite_total} onChange={handleChange} />
                </div>
                <div className="col-md-4 mb-3">
                    <label className="form-label">Límite por Cliente</label>
                    <input className="form-control" type="number" name="limite_cliente" value={formData.limite_cliente} onChange={handleChange} />
                </div>
            </div>
        </ModalBootstrap>
    );
};

export default ModalPromocion;